import React from 'react';
import palette from '@mlc/mlc-palette';
import { AEMContent, Card, Svg } from '@mlc/web-ui-toolkit';
import { exclamationTriangle } from '@mlc/symbols';
import { ZeroMargin } from '../Common/styled';

const ApiError = () => (
	<Card
		display="flex"
		alignItems="start"
		data-id="api-error"
		paddingTop={3}
		paddingBottom={5}
		margin={3}
		role="alert"
	>
		<Svg
			symbol={exclamationTriangle}
			marginTop={1}
			marginRight={2}
			color="mlcRed"
		/>
		<ZeroMargin textColor={palette.mlcRed}>
			<AEMContent path="/secure/_content/common/api-error" />
		</ZeroMargin>
	</Card>
);

export default ApiError;
